import { render, staticRenderFns } from "./close-btn-container.vue?vue&type=template&id=e48a0324&scoped=true&"
import script from "./close-btn-container.vue?vue&type=script&lang=js&"
export * from "./close-btn-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48a0324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e48a0324')) {
      api.createRecord('e48a0324', component.options)
    } else {
      api.reload('e48a0324', component.options)
    }
    module.hot.accept("./close-btn-container.vue?vue&type=template&id=e48a0324&scoped=true&", function () {
      api.rerender('e48a0324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/popups/close-btn-container.vue"
export default component.exports